/**
 * Get the appropriate color class for a progress bar based on percentage
 * @param {number} marksObtained - Marks obtained
 * @param {number} maxMarks - Maximum possible marks
 * @returns {string} CSS class name
 */
export const getProgressColor = (marksObtained, maxMarks) => {
  const percentage = maxMarks > 0 ? (marksObtained / maxMarks) * 100 : 0;
  if (percentage < 50) return "bg-red-500";
  if (percentage < 75) return "bg-yellow-500";
  return "bg-green-500";
};

/**
 * Calculate HackerRank stars based on score
 * @param {number} score - HackerRank score
 * @returns {number} Number of stars (can be decimal)
 */
export const calculateHackerRankStars = (score) => {
  if (score >= 200) return 5;
  if (score >= 150) return 4.5;
  if (score >= 100) return 4;
  if (score >= 50) return 3.5;
  if (score >= 30) return 3;
  if (score >= 20) return 2.5;
  if (score >= 10) return 2;
  if (score >= 5) return 1.5;
  if (score > 0) return 1;
  return 0;
};

/**
 * Format a section title with consistent styling
 * @param {string} title - The section title
 * @returns {JSX.Element} Formatted section title
 */
export const SectionTitle = ({ title }) => {
  return (
    <h2 className="flex items-center gap-2 pb-2 mb-4 text-lg font-bold border-b md:text-xl text-slate-900">
      <span className="w-1.5 h-6 bg-blue-600 rounded-full inline-block"></span>
      {title}
    </h2>
  );
};
